module.exports = __webpack_public_path__ + "static/media/pentagram.fd106bdb.png";